import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';

import { Observable, from, of, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry, debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.css']
})
export class VehiclesComponent extends BaseCrudComponent {

  	translations:any;
    orders:any;
    loadingRequired:any;
    status:any;
    doctypes:any;
    brands:any;
    drivers: any;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService
      ) {
        super(srv, modalService, storage, router);

        this.read_url = 'LogisticTruck/All';
        this.create_url = 'LogisticTruck/Create';
        this.update_url = 'LogisticTruck/Update';
        this.delete_url = 'LogisticTruck/LogicalDelete';
        this.search_fields = [];
        this.loadingRequired = false;
        this.doctypes = [];
        this.brands = [];

        this.reload.subscribe(val => {
            if( val ){
                super.clearData();
                this.getList();
                
            }
        });
    }

    ngOnInit() {
        this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
                this.getAllWEIHT();
                this.getAllVolum();
                this.getDriversList();//la lista de los responsables
                
                this.loadingRequired = true;
                this.getVehicleTypes().subscribe(r => {
                    
                    this.loadingRequired = false;
                    
                    if( r != false ){
                        this.doctypes = r[0];
                    }

                    this.loadingRequired = true;
                    this.getVehicleBrands().subscribe(b => {
                        this.loadingRequired = false;
                    
                        if( b != false ){
                            this.brands = b[0];
                        }
                    });
                });
        });
    }


    getDriversList(){
        this.srv.getCall('LogisticDriver/All').subscribe(x => {
            var data = x.data;
            if(x.status){
              this.drivers = data;
            }
          }),
          //timeout(MAX_TIME),
          catchError(data => {return of(false)})
        
      }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;

    }

    public getVehicleTypes(){
        var par_url = 'SystemParameter/GetByName/TRUCK_TYPE';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    weights = []
    public getAllWEIHT(){
        var par_url = 'SystemParameter/GetByName/WEIGHT';

        this.srv.getCall(par_url).subscribe(x => {
            var data = x.data;
            if(x.status){
                let myArray = data;
                for(let i=0;i<myArray.length; i++){
                  this.weights=myArray[i];
                }
              }
          }),
          //timeout(MAX_TIME),
          catchError(data => {return of(false)})
    }

    volums = []
    public getAllVolum(){
        var par_url = 'SystemParameter/GetByName/VOLUME';

        this.srv.getCall(par_url).subscribe(x => {
            var data = x.data;
            if(x.status){
              let myArray = data;
              for(let i=0;i<myArray.length; i++){
                this.volums=myArray[i];
              }
            }
          }),
          //timeout(MAX_TIME),
          catchError(data => {return of(false)})
    }

    public getVehicleBrands(){
        var par_url = 'SystemParameter/GetByName/TRUCK_BRAND';

        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    openCreateModal(content:any){
        this.c_obj = {};
        super.openCreateModal(content);
    }

    openUpdateModal(content:any, obj:any){
        this.u_obj = obj;
        this.u_obj.productionYear = this.dataConversion(obj.productionYear);
        this.u_obj.registrationExpiration = this.dataConversion(obj.registrationExpiration);
        //console.log(this.u_obj);
        super.openCreateModalLG(content);
    }

    dataConversion(value :String){
        console.log(value);
        if(value!=null){
            let arrParam = value.split("T");
            if(arrParam.length>0)
                return arrParam[0];
            return value;
        }
        return "";
    }

    validateCreateInfo(fields:any){
        let mygroup:any = {};
        mygroup = new FormGroup({
            'name': new FormControl(fields.name, [Validators.required]),
            'type': new FormControl(fields.type, [Validators.required]),
            'brand': new FormControl(fields.brand, [Validators.required]),
            'registrationNumber': new FormControl(fields.registrationNumber, [Validators.required]),
            'registrationExpiration': new FormControl(fields.registrationExpiration, [Validators.required]),
            'productionYear': new FormControl(fields.productionYear, [Validators.required]),
            'driverId': new FormControl(fields.driverId, [Validators.required]),
            'weightUMId': new FormControl(fields.weightUMId, [Validators.required]),
            'volumeUMId': new FormControl(fields.volumeUMId, [Validators.required]),
        });

        return mygroup.valid;
    } 

    vehiclePlateValidator(placa){
        // Aqui esta el patron(expresion regular) a buscar en el input
        const patronPlaca = /^[a-zA-Z]{2,3}-[0-9]{3,4}$/;
        
        return patronPlaca.test(placa);
    }

    public createItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        if(!this.vehiclePlateValidator(form.registrationNumber)){
            Swal.fire('Placa no valida', '', 'error');
            return;
        }

        var to:any;
        to = form;

        var qst = this.create_url;
        this.isCreating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isCreating = false;
            if(x.status){
                this.c_obj = {};
                this.getList();
                this.closeModal(content);
                Swal.fire('Creado', '', 'success');
            }//end success
            else{
                //Swal.fire(this.translations[x.msg], '', 'error');
                Swal.fire(x.message, '', 'error');
            }
        });
    }

    public updateItem(content:any, form:any){
        var validated = true;

        if( form == undefined ){
          form = {};
        }

        validated = this.validateCreateInfo(form);
        if( !validated ){
            Swal.fire(this.translations['msg_all_required'], '', 'error');
            return;
        }

        var to:any;
        to = form;

        var qst = this.update_url;
        this.isUpdating = true;

        this.srv.postCall(qst, to).subscribe(x => {
            this.isUpdating = false;
            if(x.status){
                this.getList();
                this.closeModal(content);
                Swal.fire(this.translations['updated'], '', 'success');
            }//end success
            else{
                Swal.fire(x.message, '', 'error');
              //this.closeModal(content);
            }
        });
    }

}
